import React from 'react';
import { styled, Typography } from '@mui/material';
import { HEADER_CONSTANTS } from '../../constants';
import DocumentGenerationJobCreateButton from '../DocumentGenerationJobCreateButton/DocumentGenerationJobCreateButton';

const HeaderWrapper = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '20px',
});

interface DocumentGenerationJobPageHeaderProps {
  showCreateButton?: boolean;
}

const DocumentGenerationJobPageHeader = ({ showCreateButton = true }: DocumentGenerationJobPageHeaderProps) => (
  <HeaderWrapper>
    <Typography variant="h1" style={{ fontWeight: 'bold' }}>
      {HEADER_CONSTANTS.TITLE}
    </Typography>
    {showCreateButton && <DocumentGenerationJobCreateButton />}
  </HeaderWrapper>
);

export default DocumentGenerationJobPageHeader;
